<template>
  <div class="cases-resubmit">
    <div class="cases-numbers-input">
      <vue-tags-input
        :key="reloadTags"
        v-model="caseNumber"
        :add-on-key="[13, ',', ';', ' ']"
        :separators="[',', ';', ' ']"
        :avoid-adding-duplicates="false"
        :placeholder="t('admin.resubmit_cases_placeholder')"
        @tags-changed="updateCaseNumbers" />
      <backstage-button @click="resubmitCases">
        {{ t('admin.resubmit_cases') }}
      </backstage-button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useNotification } from '@/composables/useNotification';
import { CasesService } from '@/services/cases.service';
import { VueTagsInput } from '@sipec/vue3-tags-input';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import BackstageButton from '../../components/common/BackstageButton.vue';

type CaseNumberTag = {
  text: string;
};

const { t } = useI18n();
const { notifySuccess, notifyError } = useNotification();
const casesService = new CasesService();

const caseNumberList = ref<CaseNumberTag[]>([]);
const caseNumber = ref('');
const reloadTags = ref(0);

function updateCaseNumbers(newCaseNumberList: CaseNumberTag[]) {
  caseNumberList.value = newCaseNumberList;
}

function resetCaseNumbersInput() {
  caseNumber.value = '';
  caseNumberList.value = [];
  reloadTags.value++;
}

async function resubmitCases() {
  try {
    const caseNumbers = caseNumberList.value.map((tag) => tag.text);
    const result = await casesService.resubmitCasesToExternalService(caseNumbers);
    const submittedCaseNumbers = result.model?.submittedCaseNumbers ?? [];

    if (submittedCaseNumbers.length) {
      notifySuccess(`${t('admin.cases_resubmitted')}${submittedCaseNumbers.join(', ')}`);
    } else {
      notifyError(t('admin.error_resubmitting_cases'));
    }
  } catch {
    notifyError(t('admin.error_resubmitting_cases'));
  } finally {
    resetCaseNumbersInput();
  }
}
</script>
<style lang="scss">
.cases-resubmit {
  @include main-max-with;

  padding: 20px 10px 0;
  width: 100%;
  margin: 0 auto;

  .vue-tags-input {
    background-color: var(--primary-bg-color);
    border: 1px solid var(--border-color);
    color: var(--primary-text-input-color);
    max-width: initial;

    .ti-tag {
      height: 45px;
      box-sizing: content-box;
    }
  }

  .cases-numbers-input {
    display: flex;
    align-items: center;
    gap: 20px;
    padding-bottom: 20px;

    .vue-tags-input {
      flex: 1;
      border: none;
      max-width: 100%;

      .ti-new-tag-input-wrapper input {
        height: 30px;
        background: transparent;
        color: #000;
      }

      .ti-tag {
        height: 30px;
      }

      .ti-content {
        margin-left: 10px;
      }

      .ti-actions {
        border-left: 1px solid;
        padding-left: 10px;
        padding-right: 5px;
        margin-left: 10px;

        .ti-icon-close:before {
          content: '\2715';
        }
      }
    }
  }
}
</style>
